import { get, post, put } from '../utils/request';

export const getStep1Data = function (parameter) {
  return get('/api/v1/step1', {}, { params: parameter });
};

export const getStep2Data = function (step2Request) {
  return post('/api/v1/step2', step2Request);
};

export const getAllInitData = function (parameter) {
  return get('/api/v1/step1/init/all', {}, { params: parameter });
};

export const getImprintThumbnails = function (vendorId, itemId) {
  return get(`/api/v1/step1/GetImprintThumbnails?vendorId=${vendorId}&itemId=${itemId}`);
};

export const getCartData = function (cartQueryRequest) {
  return get('/api/v1/cart?r=' + Math.random(), {}, { params: cartQueryRequest });
};

export const addToCartData = function (cartRequest) {
  return post('/api/v1/cart', cartRequest);
};
export const adminEditorAddToCartData = (cartRequest) => {
  return post('/api/v1/cart/AdminEditorAddToCart', cartRequest);
};
export const getCartXml = function (cartRequest) {
  return put('/api/v1/cart', cartRequest);
};
export const getRefreshedToken = () => post('/api/v1/RefreshedToken');

export const getPricingData = function (pricingRequest) {
  return post('/api/v1/pricing', pricingRequest);
};

export const recordErrorInfo = function (error) {
  return post('/api/v1/Error', error);
};

export const recordLogDebug = function (log) {
  return post('/api/v1/Log', log);
};

export const getVendor = (vendorid) => get(`/api/v1/Vendor?vendorId=${vendorid}`);

export const getToken = (tokenRequest) => post('/api/v2/Token', tokenRequest);

export const getUpsellData = function (upsellRequest) {
  return post('/api/v1/upsell', upsellRequest);
};

export const getCartUpsellsData = (cartUpsellsRequest) => {
  return get('/api/v1/upsell', {}, { params: cartUpsellsRequest });
};

export const updateCartUpsellsData = (cartUpsellsUpdateRequest) => {
  return put('/api/v1/upsell', cartUpsellsUpdateRequest);
};

export const getPromoStudioUIType = function (parameter) {
  return get('/api/v1/UIType', {}, { params: parameter });
};

export const getScene7StockImageModeData = (stockImageRequest) => {
  return get('/api/v1/cloud', {}, { params: stockImageRequest });
};

export const checkReturnUrl = (returnUrl) => {
  return get(`/api/v1/checkReturnUrl?returnUrl=${returnUrl}`);
};

export const sendOfflineChatEmail = (chatInfo) => {
  return post('/api/v1/Email/OfflineChatEmail', chatInfo);
};

export const getBomOptionsData = (parameter) => {
  return get('/api/v1/step1/getBomOptions', {}, { params: parameter });
};

export const getFontFiles = (vendorId, itemId) => {
  return get(`/api/v1/font/FontFiles?vendorId=${vendorId}&itemId=${itemId}`);
};
